<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="wip-container">
	<span class="icon-tool-kit"></span>

	<span class="title">Work in progress</span>

	<span class="message">
		The page you're trying to reach is under development. Try again later or contact support.
	</span>
</div>
